import React from 'react';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { css, StyleSheet } from 'aphrodite/no-important';
import PropTypes from 'prop-types';
// import { history } from '../../utils';
import { theme } from '../../theme';
const propTypes = {
  userHandle: PropTypes.string,
  displayName: PropTypes.string,
  showBottomRow: PropTypes.bool
};

const defaultProps = {
  userHandle: '@johndoe',
  displayName: 'John Doe',
  showBottomRow: true
};

const UserCard = (props) => {
  const history = useHistory();
  const {
    // menuBackground,
    // menuBorderColor,
    // menuTextColor,
    // fontSize,
    // fontWeight,
    menuItemTextColor,
    menuItemActiveTextColor,
    menuItemHoverTextColor,
    // menuItemDisabledTextColor,
    // menuItemDisabledTextColorOpacity,
    menuItemBackgroundColor,
    menuItemActiveBackgroundColor,
    menuItemHoverBackgroundColor,
    // menuItemDisabledBackgroundColor,
    // menuItemIndicatorColor,
    // menuItemActiveIndicatorColor,
    // menuItemHoverIndicatorColor,
    menuItemSeparatorColor
  } = theme.dropdown;

  const styles = StyleSheet.create({
    userCard: {
      color: menuItemTextColor,
      background: menuItemBackgroundColor,
      borderBottom: `1px solid ${menuItemSeparatorColor}`,
      cursor: 'pointer',
      ':hover': {
        background: menuItemHoverBackgroundColor,
        color: menuItemHoverTextColor
      }
    },
    userCardActive: {
      background: menuItemActiveBackgroundColor,
      color: menuItemActiveTextColor
    },
    menuItemLink: {
      color: 'inherit',
      background: 'inherit'
    },
    topSection: {
      display: 'flex',
      height: '41px'
    },
    avatarIcon: {
      fontSize: '50px'
    },
    // userHandle: {
    //   color: '#0080FF'
    // },
    bottomSection: {
      // color: '#0080FF',
      padding: '12px 8px 8px 8px',
      fontSize: '14px',
      fontWeight: 'bold',
      cursor: 'pointer'
    }
  });

  const handleOnClickSwitchToAdmin = () => {
    history.push('/admin/profile/about');
  };

  const handleOnClickSwitchToProvider = () => {
    history.push('/provider');
  };

  const handleOnClickUserCard = () => {
    if (props.usr.isMasterAdmin) {
      history.push('/admin/profile');
    } else {
      history.push('/user/profile/about');
    }
    if (props.setVisibility) {
      props.setVisibility(false);
    }
  };

  let profileSwitcher = <div></div>;

  if (props.usr.loggedInAs === 'admin' && props.usr.isProvider) {
    if (props.location.pathname.startsWith('/provider')) {
      profileSwitcher = (
        <div
          onClick={handleOnClickSwitchToAdmin}
        >
          Change to Admin Profile
        </div>
      );
    } else if (props.location.pathname.startsWith('/admin')) {
      profileSwitcher = (
        <div
          onClick={handleOnClickSwitchToProvider}
        >
          Change to Provider Profile
        </div>
      );
    }
  }

  if (props.usr.loggedInAs === 'provider' && props.usr.isAdmin) {
    if (props.location.pathname.startsWith('/provider')) {
      profileSwitcher = (
        <div
          onClick={handleOnClickSwitchToAdmin}
        >
          Change to Admin Profile
        </div>
      );
    } else if (props.location.pathname.startsWith('/admin')) {
      profileSwitcher = (
        <div
          onClick={handleOnClickSwitchToProvider}
        >
          Change to Provider Profile
        </div>
      );
    }
  }

  return (
    <div
      className={css(styles.userCard, props.isActive && styles.userCardActive)}
      onClick={handleOnClickUserCard}
    >
      {/* Top section */}
      <div className={css(styles.topSection)}>
        {/* Avatar */}
        <div className="pl-2 pt-1 mr-2">
          {/* <i className={`fa fa-user-md ${css(styles.avatarIcon)}`} /> */}
          <img
            src={props.usr.avatarImageUrl}
            alt="avatar"
            style={{
              width: 'auto',
              height: '50px',
              maxHeight: '50px',
              borderRadius: '4px'
            }}
          />
        </div>
        {/* User details */}
        <div className="pt-1">
          <div>
            {props.displayName}
          </div>
          <div>
            {props.usr.isMasterAdmin
              ? <Link className={css(styles.menuItemLink)} to='/admin/profile/about'>{props.userHandle}</Link>
              : <Link className={css(styles.menuItemLink)} to='/user'>{props.userHandle}</Link>
            }
          </div>
        </div>
      </div>
      {/* Card bottom section */}
      {props.showBottomRow
        ? <div className={`noselect ${css(styles.bottomSection)}`}>
          {profileSwitcher}
        </div>
        : null
      }
    </div>
  );
};

UserCard.propTypes = propTypes;
UserCard.defaultProps = defaultProps;

function mapStateToProps({ user }) {
  return { ...user };
}

export default connect(mapStateToProps, {})(UserCard);
